import { ADICIONAR_FILTRO_DATA_REJEITADA } from './types';


export default function adicionarFiltroDatasRejeitadas (filtrosAdicionados) {
  return {
    type: ADICIONAR_FILTRO_DATA_REJEITADA,
    payload: filtrosAdicionados
  }
}
